
























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';

@Component({
  name: 'ui-dropdown',
})
export default class UiDropdownComponent extends Vue {
  @Prop({ default: () => [], type: Array }) Items!: ListViewItem<any>[];
  @Prop({ default: false, type: Boolean }) multiselect: Boolean;
  @Prop({ default: null, type: String }) placeholder!: String;

  @Prop({ default: false, type: Boolean }) transformer: boolean;
  @Prop({ default: 'icon-ic_down', type: String }) icon: string;

  @Prop({ default: false, type: Boolean }) removeSelected: boolean;

  @Prop({ default: false, type: Boolean }) underline: boolean;
  @Prop({ default: false, type: Boolean }) scroll: boolean;

  @Prop({ default: '', type: String }) autocompleteText: String;
  @Prop({ default: false, type: Boolean }) autocomplete: boolean;
  @Prop({ default: '', type: String }) height: String;

  @Prop({ default: false, type: Boolean }) autoOpen: boolean;

  eShowItemsList = false;
  get ShowItemsList(): boolean {
    return this.eShowItemsList;
  }
  set ShowItemsList(value: boolean) {
    // console.log('set _ShowItemsList = ', value);
    if (!value) {
      // console.log('false');
    }
    this.$forceUpdate();
    this.eShowItemsList = value;
  }
  autoComplete = '';
  focusOn = false;
  ItemsInner = this.Items; //(this.Items).map(x => Object.assign({}, x));
  innerIcon = '';
  innerTransformer = false;
  filter: String = null;
  outside = false;
  h = 0; // высота для скролла
  styleUiSelect = {
    height: this.height,
    'align-items': 'center',
  };

  @Watch('autocompleteText')
  onChangeautocomplete() {
    if (this.autocomplete) {
      this.autoComplete = this.autocompleteText.toString();
      this.$emit('changeAutocomlite', this.autoComplete);
    }
  }

  @Watch('Items')
  onItemsChanged(items: ListViewItem<any>[]) {
    this.ItemsInner = this.Items;
  }

  @Watch('autoOpen')
  onAutoOpen() {
    // console.log("++++")
    this.ShowItemsList = true;
  }

  created() {
    this.ItemsInner = this.Items;
    //document.body.addEventListener("click", this.clickOutside.bind(this));
    this.innerIcon = this.icon;
    this.innerTransformer = this.transformer;
    // this.ShowItemsList =this.autoOpen;
    // console.log("CREATED this.ShowItemsList", this.ShowItemsList)
  }
  mounted() {
    document.body.addEventListener('click', this.clickOutside.bind(this));
    this.ShowItemsList = this.autoOpen;
  }

  onSelect(value: any) {
    if (this.multiselect) {
      this.ShowItemsList = false;
    }

    var items = this.getSelectItems();
    // this.autoComplete = '';
    if (!this.multiselect && items.length > 1) {
      console.error('Больше одного выбранного элемента, установите multiselect в true.');
    }
    this.$emit('change', items);
  }

  onClick() {
    // console.log('click');
    this.ShowItemsList = !this.ShowItemsList;
    this.innerTransformer = false;
    this.$emit('click', this.ShowItemsList);
    return false;
  }

  onClose(value: any) {
    value.Selected = false;
    if (this.multiselect) this.ShowItemsList = true;
    this.$emit('deleteItem', value);
  }

  onChange() {}
  onInputAutocomplete(res: string[]) {
    this.$emit('changeAutocomlite', res);
  }

  onEnterAutocomplete(res: any) {
    if (this.getInnerItems()[0] != null) {
      this.selectItem(this.getInnerItems()[0]);
      var items = this.getSelectItems();
      this.$emit('change', items);
    }
    // this.autoComplete = '';
    this.filter = '';
    this.ShowItemsList = false;
  }

  selectItem(value: any) {
    if (!this.multiselect) {
      this.ItemsInner.forEach((x) => (x.Selected = x.Value.id == value.Value.id));
    } else {
      this.ItemsInner[this.ItemsInner.indexOf(value)].Selected = true;
    }
  }

  getInnerItems(): Array<ListViewItem<any>> {
    if (!this.removeSelected) {
      if (this.filter != '' && this.filter != null) {
        const rez = this.ItemsInner.filter((x) => x.Value.Name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);

        return rez;
      } else {
        this.h = this.ItemsInner.length * 25 > 400 ? 400 : this.ItemsInner.length * 35;
        console.log('h=', this.ItemsInner.length);
        return this.ItemsInner;
      }
    } else {
      let rez = this.ItemsInner.filter((item) => !item.Selected);
      this.h = this.ItemsInner.length * 25 > 400 ? 400 : this.ItemsInner.length * 35;
      console.log('h=', this.ItemsInner.length);
      return rez;
    }
  }

  getSelectItems(): Array<ListViewItem<any>> {
    return this.ItemsInner.filter((item) => item.Selected);
  }

  getSelectText(): String {
    if (this.getSelectItems().length > 0) {
      this.innerTransformer = this.transformer;
      return this.getSelectItems()[0].Value.ToString();
    }
    return '';
  }

  onFocus() {
    // this.ShowItemsList = true;
  }
  onKeypress(value: any) {
    // if (this.focusOn) {
    //   this.ShowItemsList = false;
    //   this.focusOn = false;
    // } else {
    //   this.focusOn = true;
    // }
  }

  onKeyUp() {
    // console.log("onKeyUp" + this.focusOn);
  }
  onMouseLeave() {
    this.outside = true;
  }
  onMouseOver() {
    this.outside = false;
  }
  clickOutside(event: any) {
    if (!(this.$el == event.target || this.$el.contains(event.target))) {
      this.innerTransformer = this.transformer;
      if (this.ShowItemsList && this.outside) this.ShowItemsList = false;
      this.$emit('clickOutSide');
    }
  }

  destroyed() {
    document.body.removeEventListener('click', this.clickOutside.bind(this));
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-components/~/ui-dropdown/src/ui-dropdown.vue